import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';

const ConditionalRender = ({ show = true, permission, permissions, role, roles, module, action = 'view', requireAll = false, fallback = null, children }) => {
    const { checkAccess } = usePermissions();

    // If show is false, don't render
    if (!show) {
        return fallback;
    }

    // If no permission requirements, render children
    if (!permission && !permissions && !role && !roles && !module) {
        return <>{children}</>;
    }

    const hasAccess = checkAccess({
        permission,
        permissions,
        role,
        roles,
        module,
        action,
        requireAll
    });

    return hasAccess ? <>{children}</> : fallback;
};

export default ConditionalRender;
